import Backbone from "backbone";
import $ from "jquery";

export default Backbone.View.extend({

  initialize: function () {
  },

  events: {
    "change .js-Toggle-optionInput input": "render"
  },

  render: function () {
    $(".js-Toggle-optionContent").toggleClass("hidden");
  }

  });
